import type React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface StatusTabsProps {
  currentStatus: string;
  onStatusChange: (status: string) => void;
  statusCounts: Record<string, number>;
}

const statusLabels = {
  pending: "Pending Site Visit",
  assigned: "Assigned",
};

const StatusTabs: React.FC<StatusTabsProps> = ({
  currentStatus,
  onStatusChange,
}) => {
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onStatusChange(newValue);
  };
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box sx={{ mb: 3 }}>
      {/* Status Tabs */}
      <Tabs
        value={currentStatus}
        onChange={handleChange}
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: reduxTheme.primary_colors[400],
          },
          "& .MuiTab-root": {
            textTransform: "none",
          },
          "& .Mui-selected": {
            color: `${reduxTheme.primary_colors[400]} !important`,
          },
        }}
      >
        {Object.entries(statusLabels).map(([key, label]) => (
          <Tab key={key} label={label} value={key} />
        ))}
      </Tabs>
    </Box>
  );
};

export default StatusTabs;
